import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

/* THE NATIVE SPLASH STAYS UP UNTIL THE FIRST REAL SCREEN IS READY.
   It used to hide itself after the plugin's default half second, whatever the
   app was doing — so a cold start showed the light page background, then a
   loading screen, then (for a new user) a paywall, each cut in on the last.
   `launchAutoHide: false` (capacitor.config.ts) hands the decision to the web
   app: SubscriptionGate calls `releaseSplash()` once it knows which screen to
   show — signed out, entitled, or the paywall.

   The failsafe is the important half. A splash nobody hides is an app that
   never opens, so `armSplashFailsafe()` (index.js) hides it regardless after
   SPLASH_MAX_MS — longer than the auth wait plus RevenueCat's own 8s timeout
   would need on any sane connection, short enough not to look hung. */
export const SPLASH_MAX_MS = 10000;

let released = false;

export function releaseSplash() {
  if (released || !Capacitor.isNativePlatform()) return;
  released = true;
  // Never let the splash take the app down with it: this runs in a render
  // effect, so a throw (or a plugin that answers with no promise) is caught
  // here rather than reaching the error boundary.
  Promise.resolve()
    .then(() => SplashScreen.hide({ fadeOutDuration: 250 }))
    .catch(() => {});
}

export function armSplashFailsafe() {
  if (!Capacitor.isNativePlatform()) return;
  setTimeout(releaseSplash, SPLASH_MAX_MS);
}
